<mat-tab-group class="bg-white" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChanged()">

  @if(canViewEmployeesTab) {
    <mat-tab [label]="utils.getLangTerm('employees.plural', 'Employees')">
      <ng-template matTabContent>
        <app-employees></app-employees>
      </ng-template>
    </mat-tab>
  }

  @if(canViewRequestsTab) {
    <mat-tab>
      <ng-template mat-tab-label>
        Access Requests
        <!-- Never render a zero badge: an empty queue should look settled, not flagged. -->
        @if(pendingCount > 0) {
          <span class="badge badge-warning ml-2"
                matTooltip="{{ pendingCount }} request(s) awaiting your approval.">
            {{ pendingCount }}
          </span>
        }
      </ng-template>
      <ng-template matTabContent>
        <app-access-requests></app-access-requests>
      </ng-template>
    </mat-tab>
  }

</mat-tab-group>
